import { render, staticRenderFns } from "./McDataDisplay.vue?vue&type=template&id=664735fe&scoped=true&"
import script from "./McDataDisplay.vue?vue&type=script&lang=js&"
export * from "./McDataDisplay.vue?vue&type=script&lang=js&"
import style0 from "./McDataDisplay.vue?vue&type=style&index=0&id=664735fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664735fe",
  null
  
)

export default component.exports